const STORAGE_KEY = "expenses_columns_v1";

export const COLUMN_DEFS = [
  { key: "merchant", label: "Merchant", sortable: true, locked: true },
  { key: "employee", label: "Employee", sortable: true },
  { key: "department", label: "Department" },
  { key: "date", label: "Date", sortable: true },
  { key: "category", label: "Category", sortable: true },
  { key: "policy", label: "Policy" },
  { key: "policy_status", label: "In Policy" },
  { key: "receipt", label: "Receipt" },
  { key: "assigned", label: "Assigned" },
  { key: "amount", label: "Amount", sortable: true, right: true },
  { key: "status", label: "Status", sortable: true },
  { key: "gl", label: "GL" },
];

export const DEFAULT_COLUMN_CONFIG = COLUMN_DEFS.map((c) => ({ key: c.key, visible: true }));

export const loadColumnConfig = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (!Array.isArray(saved)) return DEFAULT_COLUMN_CONFIG;
    const known = saved.filter((c) => COLUMN_DEFS.some((d) => d.key === c.key));
    const missing = COLUMN_DEFS.filter((d) => !known.some((c) => c.key === d.key)).map((d) => ({ key: d.key, visible: true }));
    return [...known, ...missing];
  } catch {
    return DEFAULT_COLUMN_CONFIG;
  }
};

export const persistColumnConfig = (next) => localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
